/**
 * @author Ariel
 * @description 岗位管理
 * @Date 2019/12/28
 */
import React from "react";
import { connect } from "dva";
import { templateConfig, reduxTemplateCofig } from "./config";

import { component_tool, framework_tool } from '../../../tool';
let { WizContainer, WizReduxTemplate, modelUtils } = framework_tool;
let { WizBrowserExport } = component_tool;


class PositionManager extends WizContainer {
  componentName = 'positionManager';

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  _componentDidMount() {
    this.doActions([
      {
        path: 'positionCategory/getPositionCategoryList', //获取岗位分类列表
        payload: {
          key: 'positionCategory_getPositionCategoryList',
          apiParams: {
            type: 'FOLDER'
          }
        },
        requireLoading: true,
      }
    ])
  }

  propsAndStateOnChange = {
    positionCategoryList: this.positionCategoryListOnChange.bind(this)
  }

  positionCategoryListOnChange(nextProps, nextState) {
    let _list = [];
    if (nextProps['positionCategoryList'] && nextProps['positionCategoryList']['success'] === true) {
      let list = nextProps["positionCategoryList"]['data']
      list && list.forEach(val => {
        _list.push({ code: val['id'], codeName: val['name'] })
      });
      nextState['positionCategoryList'] = _list;
      return true;
    } else {
      wizNotice.error(_nextProps["positionCategoryList"]['msg'])
      return false;
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '岗位名称',
        field: 'name',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '岗位编码',
        field: 'code',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '岗位分类',
        field: 'positionCategoryNames',
        width: 50,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '所属组织',
        field: 'orgNames',
        width: 50,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '状态',
        field: 'positionState',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '创建人',
        field: 'createBy',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '创建时间',
        field: 'createTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '修改人',
        field: 'updateBy',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '修改时间',
        field: 'updateTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      }
    ]
    if (o['success']) {
      let data = o['data']
      WizBrowserExport({
        title: '岗位信息',
        sheetName: '岗位信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '岗位信息.xlsx',
      })
      // wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let {positionCategoryList} = this.state
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig({positionCategoryList:positionCategoryList}),
      apiDataFormat: {
        delete: this._handleCMD,
        export: this._handleFile
      },
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  const { positionCategory } = state;
  const positionCategoryList = modelUtils.getModelEntity(positionCategory, "positionCategory_getPositionCategoryList");
  const load = modelUtils.getLoadingState(state, 'positionCategory');
  return {
    positionCategoryList: positionCategoryList,
    ...load
  }
};

export default connect(mapStateToProps)(PositionManager);
